<div class="horizontal-items h-100">
    <div class="sorting-block d-flex gap-20 justify-content-between flex-wrap flex-sm-nowrap"
        *ngIf="router.url == '/dashboard/engagement/engagement-list'">
        <mat-form-field class="fixed-label label-none" floatLabel="always" style="max-width: 300px;">
            <mat-label>Search</mat-label>
            <mat-select placeholder="Select" [disableOptionCentering]="true" [(ngModel)]="enagementFilter"
                (selectionChange)="engagementFilter($event)">
                <mat-option *ngFor="let filter of engagementListFilter" [value]="filter.value">
                    {{ filter.viewValue }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <button mat-button mat-stroked-button class="button-default" color="dark" [disabled]="disableExportBtn"
            (click)="exportEngagementList()">
            <i class="fa-regular fa-file-export"></i><span class="button-label">Export</span>
        </button>

    </div>
    @if (isEngagementListAvailable || enagementFilter === sixMonthsFilter) {
    <div class="card table-responsive engagement-tbl-list" appSpin [spinnerConfig]='spinnerConfig()'>
        <ng-container *ngIf="router.url == '/dashboard/members/client-engagements'">
            <table class="table-countable template-edit-table" mat-table [dataSource]="gridDataEngage"
                multiTemplateDataRows [trackBy]="trackByEngList">

                <!-- checkBox Column -->
                <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef>
                        <ng-container *ngIf="router.url == '/dashboard/members/client-engagements'">
                            <mat-checkbox [(ngModel)]="gridDataEngage.data.checked"
                                [checked]="isEngListAllSelected ? 'true' : false"
                                (ngModelChange)="isEngListAllSelected ? selectedItemsData(gridDataEngage.data) : isSelectedAll(gridDataEngage.data)"
                                (click)="$event.stopPropagation()"></mat-checkbox>
                            <!--Parent CheckBox  selectedItemsData-->
                        </ng-container>

                    </th>
                    <td mat-cell *matCellDef="let element">
                        <ng-container *ngIf="router.url == '/dashboard/members/client-engagements'">
                            <mat-checkbox [(ngModel)]="element.checked" [checked]="element.checked"
                                (ngModelChange)="selectedItemsData(gridDataEngage.data, element)"
                                (click)="$event.stopPropagation()"></mat-checkbox> <!--Child CheckBox-->
                        </ng-container>

                    </td>
                </ng-container>
                <!-- Engagement Name Column -->
                <ng-container matColumnDef="engagementName">
                    <th mat-header-cell *matHeaderCellDef>
                        <span>Engagement ID </span>
                        <button mat-button class="mat-icon-button table-sort-button"
                            [matMenuTriggerFor]="menuEngagementName"
                            [ngClass]="{'active': selectedSortOptions?.engagementName === 'asc' || selectedSortOptions?.engagementName === 'dec'}">
                            <i class="fa-regular fa-arrow-up-arrow-down text-primary-darker"
                                *ngIf="selectedSortOptions?.engagementName === 'def'"></i>
                            <i class="fa-regular fa-arrow-up-long text-primary-darker"
                                *ngIf="selectedSortOptions?.engagementName === 'asc'"></i>
                            <i class="fa-regular fa-arrow-down-long text-primary-darker"
                                *ngIf="selectedSortOptions?.engagementName === 'dec'"></i>
                        </button>
                        <mat-menu #menuEngagementName="matMenu">
                            <button mat-menu-item (click)="customSortData('engagementName', 'asc')"
                                class="transparent-btn" [ngClass]="{'bg-gray-1' : isAscSortMode}">
                                <span class="flexbox-row gap-8">
                                    <i class="fa-regular fa-arrow-up-long"></i>
                                    Ascending Order
                                </span>
                            </button>
                            <button mat-menu-item (click)="customSortData('engagementName', 'dec')"
                                class="transparent-btn" [ngClass]="{'bg-gray-1' : isDesSortMode}">
                                <span class="flexbox-row gap-8">
                                    <i class="fa-regular fa-arrow-up-long"></i>
                                    Descending Order
                                </span>
                            </button>
                        </mat-menu>
                    </th>
                    <td mat-cell *matCellDef="let element; let rowIndex = dataIndex" title="{{element.engagementName}}">
                        <ng-container *ngIf="!permissions?.hasEngView; else showEngagements">
                            {{ element.engagementName }}
                        </ng-container>
                        <ng-template #showEngagements>
                            <button mat-button title="{{element.engagementName}}"
                                (click)="redirectToTrialBal(element, rowIndex)" class="text-ellipse text-link">{{
                                element.engagementName }}
                            </button>
                        </ng-template>
                    </td>
                </ng-container>

                <!-- Client Name Column -->

                <ng-container matColumnDef="clientName">
                    <th mat-header-cell *matHeaderCellDef>
                        <span>Client Name </span>
                    </th>
                    <td mat-cell *matCellDef="let element" title="{{(element.clientName ? element.clientName : '')}}">
                        {{ (element.clientName ? element.clientName : '') }}
                    </td>
                </ng-container>

                <!-- type Column -->
                <ng-container matColumnDef="engagementtype">
                    <th mat-header-cell *matHeaderCellDef>
                        <span>Type </span>
                        <button mat-button class="mat-icon-button table-sort-button" [matMenuTriggerFor]="menuType"
                            [ngClass]="{'active': selectedSortOptions?.engagementtype === 'asc' || selectedSortOptions?.engagementtype === 'dec'}">
                            <i class="fa-regular fa-arrow-up-arrow-down text-primary-darker"
                                *ngIf="selectedSortOptions?.engagementtype === 'def'"></i>
                            <i class="fa-regular fa-arrow-up-long text-primary-darker"
                                *ngIf="selectedSortOptions?.engagementtype === 'asc'"></i>
                            <i class="fa-regular fa-arrow-down-long text-primary-darker"
                                *ngIf="selectedSortOptions?.engagementtype === 'dec'"></i>
                        </button>
                        <mat-menu #menuType="matMenu">
                            <button mat-menu-item (click)="customSortData('engagementtype', 'asc')"
                                class="transparent-btn" [ngClass]="{'bg-gray-1' : isAscSortMode}">
                                <span class="flexbox-row gap-8">
                                    <i class="fa-regular fa-arrow-up-long"></i>
                                    Ascending Order
                                </span>
                            </button>
                            <button mat-menu-item (click)="customSortData('engagementtype', 'dec')"
                                class="transparent-btn" [ngClass]="{'bg-gray-1' : isDesSortMode}">
                                <span class="flexbox-row gap-8">
                                    <i class="fa-regular fa-arrow-up-long"></i>
                                    Descending Order
                                </span>
                            </button>
                        </mat-menu>
                    </th>
                    <td mat-cell *matCellDef="let element" title="{{element.engagementtype}}"> {{ element.engagementtype
                        }}
                    </td>
                </ng-container>

                <!-- Year End Date Column -->
                <ng-container matColumnDef="yearEnd">
                    <th mat-header-cell *matHeaderCellDef>Period/Year End Date
                        <button mat-button class="mat-icon-button table-sort-button" [matMenuTriggerFor]="menuYearEnd"
                            [ngClass]="{'active': selectedSortOptions?.yearEnd === 'asc' || selectedSortOptions?.yearEnd === 'dec'}">
                            <i class="fa-regular fa-arrow-up-arrow-down text-primary-darker"
                                *ngIf="selectedSortOptions?.yearEnd === 'def'"></i>
                            <i class="fa-regular fa-arrow-up-long text-primary-darker"
                                *ngIf="selectedSortOptions?.yearEnd === 'asc'"></i>
                            <i class="fa-regular fa-arrow-down-long text-primary-darker"
                                *ngIf="selectedSortOptions?.yearEnd === 'dec'"></i>
                        </button>
                        <mat-menu #menuYearEnd="matMenu">
                            <button mat-menu-item (click)="customSortData('yearEnd', 'asc')" class="transparent-btn"
                                [ngClass]="{'bg-gray-1' : isAscSortMode}">
                                <span class="flexbox-row gap-8">
                                    <i class="fa-regular fa-arrow-up-long"></i>
                                    Ascending Order
                                </span>
                            </button>
                            <button mat-menu-item (click)="customSortData('yearEnd', 'dec')" class="transparent-btn"
                                [ngClass]="{'bg-gray-1' : isDesSortMode}">
                                <span class="flexbox-row gap-8">
                                    <i class="fa-regular fa-arrow-up-long"></i>
                                    Descending Order
                                </span>
                            </button>
                        </mat-menu>
                    </th>
                    <td mat-cell *matCellDef="let element" title="{{element.yearEnd}}">{{ element.yearEnd }}</td>
                </ng-container>

                    <!-- assignedTo Column -->
                    <ng-container matColumnDef="assignedTo">
                        <th mat-header-cell *matHeaderCellDef>
                            <span>Assigned Team </span>
                        </th>
                        <td mat-cell *matCellDef="let element" title="{{element.assignedTo}}">
                            <button mat-button class="text-button" [disabled]="element.statusid == 21"
                                    (click)="expandedElement = expandedElement === element ? null : element">{{ element.assignedTo }}
                            </button>
                        </td>
                    </ng-container>

                <!-- Status Column -->
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef>
                        Status
                        <button mat-icon-button [matMenuTriggerFor]="statusFilter">
                            <i class="fa-solid fa-bars-filter fs-15"></i>
                        </button>
                        <mat-menu #statusFilter="matMenu" class="filterContent status-lab" #beforeMenu="matMenu"
                            xPosition="before">
                            <div (click)="$event.stopPropagation()">
                                <button mat-menu-item *ngFor="let status of engagementsStatusLabels">
                                    <mat-checkbox ([ngModel])="status.statusname"
                                        (change)="engagementsStatusFilter($event.checked, status.statusname)">{{
                                        status.statusname }}
                                    </mat-checkbox>
                                    <!--[(ngModel)]=""-->
                                </button>
                            </div>
                        </mat-menu>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <p title="{{element.status}}" class="badge badge-pills badge-small {{element.statusClass}}">
                            {{ element.status }}
                        </p>
                        @if (element.isRfTemplate) {
                        <p title="RF" class="badge badge-primary badge-pills badge-small">RF</p>
                        }
                    </td>
                </ng-container>
                <!-- Date Created Column -->
                <ng-container matColumnDef="dateCreated">
                    <th mat-header-cell *matHeaderCellDef>
                        Date Created
                        <button mat-button class="mat-icon-button table-sort-button"
                            [matMenuTriggerFor]="menuDateCreated"
                            [ngClass]="{'active': selectedSortOptions?.dateCreated === 'asc' || selectedSortOptions?.dateCreated === 'dec'}">
                            <i class="fa-regular fa-arrow-up-arrow-down text-primary-darker"
                                *ngIf="selectedSortOptions?.dateCreated === 'def'"></i>
                            <i class="fa-regular fa-arrow-up-long text-primary-darker"
                                *ngIf="selectedSortOptions?.dateCreated === 'asc'"></i>
                            <i class="fa-regular fa-arrow-down-long text-primary-darker"
                                *ngIf="selectedSortOptions?.dateCreated === 'dec'"></i>
                        </button>
                        <mat-menu #menuDateCreated="matMenu">
                            <button mat-menu-item (click)="customSortData('dateCreated', 'asc')" class="transparent-btn"
                                [ngClass]="{'bg-gray-1' : isAscSortMode}">
                                <span class="flexbox-row gap-8">
                                    <i class="fa-regular fa-arrow-up-long"></i>
                                    Ascending Order
                                </span>
                            </button>
                            <button mat-menu-item (click)="customSortData('dateCreated', 'dec')" class="transparent-btn"
                                [ngClass]="{'bg-gray-1' : isDesSortMode}">
                                <span class="flexbox-row gap-8">
                                    <i class="fa-regular fa-arrow-up-long"></i>
                                    Descending Order
                                </span>
                            </button>
                        </mat-menu>
                    </th>
                    <td mat-cell *matCellDef="let element" title="{{element.dateCreated }}" class="position-relative">
                        {{ element.dateCreated }}
                        <span *ngIf="element?.isSpinShown" class="smooth-gradient-ring-s action-loader"></span>
                    </td>
                </ng-container>

                    <!-- Actions Column -->
                    <ng-container matColumnDef="actions" stickyEnd>
                        <th mat-header-cell *matHeaderCellDef class="w-90 text-center">
                            Actions
                        </th>
                        <td mat-cell *matCellDef="let element ; let rowIndex = dataIndex" class="w-90">
                            <div class="button-group justify-content-end w-100 flex-nowrap gap-12">
                                <ng-container *ngIf="router.url == '/dashboard/engagement/engagement-list'">
                                    <button mat-button title="Edit" class="button-text"
                                            [disabled]="!permissions?.hasEngEdit || element.statusid == 8 || element.statusid == 19 || (firm?.isPaused || billing?.isPaused) || (firm?.isDeleted || firm?.isDeleteInProgress) ||  element.statusid == 21"
                                            (click)="editEngagement(element, 'allEngagements')">
                                        <i class="fa-regular fa-pen fs-15"></i>
                                    </button>
                                </ng-container>
                                <ng-container *ngIf="router.url == '/dashboard/members/client-engagements'">
                                    <button mat-button title="Edit" class="button-text"
                                            [disabled]="!permissions?.hasEngEdit || element.statusid == 8 || element.statusid == 19 || (firm?.isPaused || billing?.isPaused) || (firm?.isDeleted || firm?.isDeleteInProgress) || element.statusid == 21"
                                            (click)="(!permissions?.hasEngEdit || element.statusid == 8 || element.statusid == 19 || (firm?.isPaused || billing?.isPaused) || (firm?.isDeleted || firm?.isDeleteInProgress))!= true ? editEngagement(element, 'clientEngagemente'):''">
                                        <i class="fa-regular fa-pen fs-15"></i>
                                    </button>
                                </ng-container>

                                <button mat-button title="Delete" class="button-text"
                                        (click)="((element.statusid == 8 || element.statusid == 19) || !permissions?.hasEngDelete) != true ? deleteEngagement(element, element.engagementName, rowIndex):''"
                                        [disabled]="(element.statusid == 8 || element.statusid == 19 || element.statusid == 21) || !permissions?.hasEngDelete"
                                        [ngClass]="{'general':(element.statusid == 8 || element.statusid == 19) || !permissions?.hasEngDelete}">
                                    <i class="fa-regular fa-trash-can"></i>
                                </button>
                            </div>
                        </td>
                    </ng-container>

                <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                <ng-container matColumnDef="expandedDetail">
                    <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                        <div class="expand-engList-detail"
                            [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                            <!-- <div class="auditor-firm team-details-row"> -->
                            <div class="team-details ps-4">
                                <ng-container *ngIf="element.auditorsData != 0 else noFirmTeam">
                                    <ul class="no-marg team-details-header">
                                        <li class="no-pad no-border">
                                            <div class="team-details-container flex-box-left">
                                                <div class="team-member" style="width: 220px;">
                                                    <div class="team-title">Firm Team</div>
                                                </div>
                                                <div class="team-member" style="width: 206px;">
                                                    <div class="team-title">Email</div>
                                                </div>
                                                <div class="team-member" style="width: 220px;">
                                                    <div class="team-title">Phone</div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </ng-container>
                                <ng-template #noFirmTeam>
                                    <div class="flex-box" style="width: 100%; height: 100%;">
                                        <div class="team-title">Firm Team not assigned</div>
                                    </div>
                                </ng-template>
                                <ul>
                                    <li *ngFor="let auditorDetails of element.auditorsData">
                                        <div class="team-details-container flex-box-col flex-box-left">
                                            <div class="team-member">
                                                <div class="team-member-short-name">
                                                    <ngx-avatars initialsSize="2" size="32"
                                                        [name]="auditorDetails.fullname"></ngx-avatars>
                                                </div>
                                                <div class="team-member-full-name">
                                                    <h6 title="{{element.fullname}}">{{ auditorDetails.fullname }}</h6>
                                                    <p>
                                                        <i>{{ getRoleCount(auditorDetails.rowindex) }} {{ ' ' +
                                                            auditorDetails.rolename }}</i>
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="team-member">
                                                <div class="team-member-email">
                                                    <i class="fa-regular fa-envelope ico"></i>
                                                    <span class="user-name">{{ auditorDetails.emailaddress }}</span>
                                                </div>
                                            </div>
                                            <div class="team-member">
                                                <div class="team-member-phone">
                                                    <i class="fa-regular fa-phone ico"></i>
                                                    <span class="user-name">{{ auditorDetails.cellno }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </li>

                                </ul>
                            </div>

                            <div class="team-details">
                                <ul class="no-marg team-details-header">
                                    <li class="no-pad no-border">
                                        <div class="team-details-container flex-box-left">
                                            <div class="team-member" style="width: 220px;">
                                                <div class="team-title">Client Team</div>
                                            </div>
                                            <div class="team-member" style="width: 206px;">
                                                <div class="team-title">Email</div>
                                            </div>
                                            <div class="team-member" style="width: 220px;">
                                                <div class="team-title">Phone</div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>

                                <ul>
                                    <li>
                                        <div class="team-details-container flex-box-col flex-box-left">
                                            <div class="team-member">
                                                <div class="team-member-short-name">
                                                    <ngx-avatars initialsSize="2" size="32"
                                                        [name]="element.contactperson"></ngx-avatars>
                                                    <!-- {{getShortName(element.contactperson)}} -->
                                                </div>
                                                <div class="team-member-full-name">
                                                    <h6 title="{{element.contactperson}}">{{ element.contactperson }}
                                                    </h6>
                                                    <p><i>Contact Person</i></p>
                                                </div>
                                            </div>
                                            <div class="team-member">
                                                <div class="team-member-email">
                                                    <i class="fa-regular fa-envelope ico"></i>
                                                    <span class="user-name">{{ element.emailaddress ?
                                                        element.emailaddress : '-' }}</span>
                                                </div>
                                            </div>
                                            <div class="team-member">
                                                <div class="team-member-phone">
                                                    <i class="fa-regular fa-phone ico"></i>
                                                    <span class="user-name">{{ element.cellphonenumber ?
                                                        element.cellphonenumber : '-' }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </li>

                                </ul>
                            </div>
                            <!-- </div> -->
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>

                <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="expanded-element-row"
                    [class.cust-expand-row]="expandedElement === element"></tr>

                <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="expanded-detail-row"
                    [class.cust-expanded-details-row]="expandedElement === row"></tr>
            </table>
        </ng-container>

        <ng-container *ngIf="router.url == '/dashboard/engagement/engagement-list'">
            <table class="table-countable template-edit-table" mat-table [dataSource]="gridDataEngage"
                multiTemplateDataRows [trackBy]="trackByEngList">

                <!-- checkBox Column -->
                <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef class="checkBox-col">
                        <ng-container *ngIf="router.url == '/dashboard/members/client-engagements'">
                            <mat-checkbox class="custom-checkbox" [(ngModel)]="gridDataEngage.data.checked"
                                [checked]="isEngListAllSelected ? 'true' : false"
                                (ngModelChange)="isEngListAllSelected ? selectedItemsData(gridDataEngage.data) : isSelectedAll(gridDataEngage.data)"
                                (click)="$event.stopPropagation()"></mat-checkbox>
                            <!--Parent CheckBox  selectedItemsData-->
                        </ng-container>

                    </th>
                    <td mat-cell *matCellDef="let element" class="checkBox-col">
                        <ng-container *ngIf="router.url == '/dashboard/members/client-engagements'">
                            <mat-checkbox class="custom-checkbox" [(ngModel)]="element.checked"
                                [checked]="element.checked" (ngModelChange)="selectedItemsData(gridDataEngage.data)"
                                (click)="$event.stopPropagation()"></mat-checkbox> <!--Child CheckBox-->
                        </ng-container>

                        </td>
                    </ng-container>
                    <!-- Engagement ID Column -->
                    <ng-container matColumnDef="engagementName">
                        <th mat-header-cell *matHeaderCellDef class="engagment-col">
                            <span>Engagement ID </span>
                            <button mat-button class="mat-icon-button table-sort-button"
                                    [matMenuTriggerFor]="menuEngagementName"
                                    [ngClass]="{'active': selectedSortOptions?.engagementName === 'asc' || selectedSortOptions?.engagementName === 'dec'}">
                                <i class="fa-regular fa-arrow-up-arrow-down text-primary-darker"
                                   *ngIf="selectedSortOptions?.engagementName === 'def'"></i>
                                <i class="fa-regular fa-arrow-up-long text-primary-darker"
                                   *ngIf="selectedSortOptions?.engagementName === 'asc'"></i>
                                <i class="fa-regular fa-arrow-down-long text-primary-darker"
                                   *ngIf="selectedSortOptions?.engagementName === 'dec'"></i>
                            </button>
                            <mat-menu #menuEngagementName="matMenu">
                                <button mat-menu-item (click)="customSortData('engagementName', 'asc')"
                                        class="transparent-btn"
                                        [ngClass]="{'bg-gray-1' : isAscSortMode}">
                <span class="flexbox-row gap-8">
                    <i class="fa-regular fa-arrow-up-long"></i>
                    Ascending Order
                </span>
                                </button>
                                <button mat-menu-item (click)="customSortData('engagementName', 'dec')"
                                        class="transparent-btn"
                                        [ngClass]="{'bg-gray-1' : isDesSortMode}">
                <span class="flexbox-row gap-8">
                    <i class="fa-regular fa-arrow-up-long"></i>
                    Descending Order
                </span>
                                </button>
                            </mat-menu>
                        </th>
                        <td mat-cell *matCellDef="let element; let rowIndex = dataIndex" class="engagment-coltd"
                            title="{{element.engagementName}}">
                            <ng-container *ngIf="!permissions?.hasEngView; else showEngagements">
                                <p title="{{element.engagementName}}"
                                   class="ellipse no-marg">{{ element.engagementName }}</p>
                            </ng-container>
                            <ng-template #showEngagements>
                                <button mat-button title="{{element.engagementName}}" [disabled]="element.statusid == 21"
                                        (click)="redirectToTrialBal(element, rowIndex)"
                                        class="text-button">{{ element.engagementName }}
                                </button>
                            </ng-template>
                        </td>
                    </ng-container>

                <!-- Client Name Column -->

                <ng-container matColumnDef="clientName">
                    <th mat-header-cell *matHeaderCellDef class="clientname-col" style="max-width: 200px;">
                        <span>Client Name </span>
                        <button mat-button class="mat-icon-button table-sort-button"
                            [matMenuTriggerFor]="menuClientName"
                            [ngClass]="{'active': selectedSortOptions?.clientName === 'asc' || selectedSortOptions?.clientName === 'dec'}">
                            <i class="fa-regular fa-arrow-up-arrow-down text-primary-darker"
                                *ngIf="selectedSortOptions?.clientName === 'def'"></i>
                            <i class="fa-regular fa-arrow-up-long text-primary-darker"
                                *ngIf="selectedSortOptions?.clientName === 'asc'"></i>
                            <i class="fa-regular fa-arrow-down-long text-primary-darker"
                                *ngIf="selectedSortOptions?.clientName === 'dec'"></i>
                        </button>
                        <mat-menu #menuClientName="matMenu">
                            <button mat-menu-item (click)="customSortData('clientName', 'asc')" class="transparent-btn"
                                [ngClass]="{'bg-gray-1' : isAscSortMode}">
                                <span class="flexbox-row gap-8">
                                    <i class="fa-regular fa-arrow-up-long"></i>
                                    Ascending Order
                                </span>
                            </button>
                            <button mat-menu-item (click)="customSortData('clientName', 'dec')" class="transparent-btn"
                                [ngClass]="{'bg-gray-1' : isDesSortMode}">
                                <span class="flexbox-row gap-8">
                                    <i class="fa-regular fa-arrow-up-long"></i>
                                    Descending Order
                                </span>
                            </button>
                        </mat-menu>

                    </th>
                    <td mat-cell *matCellDef="let element" class="clientname-coltd"
                        title="{{(element.clientName ? element.clientName : '')}}" style="max-width: 200px;">
                        <p class="text-ellipse no-marg">{{ (element.clientName ? element.clientName : '') }}</p>
                    </td>
                </ng-container>

                <!-- type Column -->
                <ng-container matColumnDef="engagementtype">
                    <th mat-header-cell *matHeaderCellDef class="col-type">
                        <span>Type </span>
                        <button mat-button class="mat-icon-button table-sort-button" [matMenuTriggerFor]="menuType"
                            [ngClass]="{'active': selectedSortOptions?.engagementtype === 'asc' || selectedSortOptions?.engagementtype === 'dec'}">
                            <i class="fa-regular fa-arrow-up-arrow-down text-primary-darker"
                                *ngIf="selectedSortOptions?.engagementtype === 'def'"></i>
                            <i class="fa-regular fa-arrow-up-long text-primary-darker"
                                *ngIf="selectedSortOptions?.engagementtype === 'asc'"></i>
                            <i class="fa-regular fa-arrow-down-long text-primary-darker"
                                *ngIf="selectedSortOptions?.engagementtype === 'dec'"></i>
                        </button>
                        <mat-menu #menuType="matMenu">
                            <button mat-menu-item (click)="customSortData('engagementtype', 'asc')"
                                class="transparent-btn" [ngClass]="{'bg-gray-1' : isAscSortMode}">
                                <span class="flexbox-row gap-8">
                                    <i class="fa-regular fa-arrow-up-long"></i>
                                    Ascending Order
                                </span>
                            </button>
                            <button mat-menu-item (click)="customSortData('engagementtype', 'dec')"
                                class="transparent-btn" [ngClass]="{'bg-gray-1' : isDesSortMode}">
                                <span class="flexbox-row gap-8">
                                    <i class="fa-regular fa-arrow-up-long"></i>
                                    Descending Order
                                </span>
                            </button>
                        </mat-menu>
                    </th>
                    <td mat-cell *matCellDef="let element" class="col-typetd" title="{{element.engagementtype}}">
                        <p class="ellipse no-marg">{{ element.engagementtype }} </p>
                    </td>
                </ng-container>

                <!-- Year End Date Column -->
                <ng-container matColumnDef="yearEnd">
                    <th mat-header-cell *matHeaderCellDef class="col-yearEnd">
                        <span>Period/Year End Date </span>
                        <button mat-button class="mat-icon-button table-sort-button" [matMenuTriggerFor]="menuYearEnd"
                            [ngClass]="{'active': selectedSortOptions?.yearEnd === 'asc' || selectedSortOptions?.yearEnd === 'dec'}">
                            <i class="fa-regular fa-arrow-up-arrow-down text-primary-darker"
                                *ngIf="selectedSortOptions?.yearEnd === 'def'"></i>
                            <i class="fa-regular fa-arrow-up-long text-primary-darker"
                                *ngIf="selectedSortOptions?.yearEnd === 'asc'"></i>
                            <i class="fa-regular fa-arrow-down-long text-primary-darker"
                                *ngIf="selectedSortOptions?.yearEnd === 'dec'"></i>
                        </button>
                        <mat-menu #menuYearEnd="matMenu">
                            <button mat-menu-item (click)="customSortData('yearEnd', 'asc')" class="transparent-btn"
                                [ngClass]="{'bg-gray-1' : isAscSortMode}">
                                <span class="flexbox-row gap-8">
                                    <i class="fa-regular fa-arrow-up-long"></i>
                                    Ascending Order
                                </span>
                            </button>
                            <button mat-menu-item (click)="customSortData('yearEnd', 'dec')" class="transparent-btn"
                                [ngClass]="{'bg-gray-1' : isDesSortMode}">
                                <span class="flexbox-row gap-8">
                                    <i class="fa-regular fa-arrow-up-long"></i>
                                    Descending Order
                                </span>
                            </button>
                        </mat-menu>
                    </th>
                    <td mat-cell *matCellDef="let element" title="{{element.yearEnd}}" class="col-year"><span
                            class="ellipse">
                            {{ element.yearEnd }}</span></td>
                </ng-container>

                    <!-- assignedTo Column -->
                    <ng-container matColumnDef="assignedTo">
                        <th mat-header-cell *matHeaderCellDef class="col-assignedTo">
                            <span>Assigned Team </span>
                        </th>
                        <td mat-cell *matCellDef="let element" class="col-assignedTotd" title="{{element.assignedTo}}">
                            <button mat-button class="text-button" [disabled]="element.statusid == 21"
                                    (click)="expandedElement = expandedElement === element ? null : element">{{ element.assignedTo }}
                            </button>
                        </td>
                    </ng-container>

                <!-- Status Column -->
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef class="col-status">
                        Status
                        <button mat-icon-button [matMenuTriggerFor]="statusFilter">
                            <i class="fa-solid fa-bars-filter fs-15"></i>
                        </button>
                        <mat-menu #statusFilter="matMenu" #beforeMenu="matMenu" xPosition="before">
                            <div (click)="$event.stopPropagation()">
                                <div class="button-group p-2 justify-content-end">
                                    <button mat-button class="button-text fs-12" (click)="clearFilters()">Clear
                                        All
                                    </button>
                                </div>
                                <button mat-menu-item title="{{status.statusname}}"
                                    *ngFor="let status of engagementsStatusLabels">
                                    <mat-checkbox [checked]="status.IsSelected"
                                        (change)="engagementsStatusFilter($event.checked, status.statusname)">{{
                                        status.statusname }}
                                    </mat-checkbox>
                                </button>
                            </div>
                        </mat-menu>
                    </th>
                    <td mat-cell *matCellDef="let element" class="col-status">
                        <p title="{{element.status}}" class="badge badge-pills badge-small {{element.statusClass}}">{{
                            element.status }}
                        </p>
                        @if (element.isRfTemplate) {
                        <p title="RF" class="badge badge-primary badge-pills badge-small">RF</p>
                        }
                    </td>
                </ng-container>

                <!--Duration-->
                <!--<ng-container matColumnDef="duration">
                        <th mat-header-cell *matHeaderCellDef class="col-dateCreated">
                          <span>Duration</span>
                        </th>
                        <td mat-cell *matCellDef="let element" title="{{element.duration=='0'?'-  ':element.duration }}" class="col-date">
                          <span class="ellipse">{{element.duration=='0'?'-  ':element.duration}}</span>
                        </td>
                      </ng-container>-->
                <!-- Date Created Column -->
                <ng-container matColumnDef="dateCreated">
                    <th mat-header-cell *matHeaderCellDef class="col-date">
                        <span>Date Created </span>
                        <button mat-button class="mat-icon-button table-sort-button"
                            [matMenuTriggerFor]="menuDateCreated"
                            [ngClass]="{'active': selectedSortOptions?.dateCreated === 'asc' || selectedSortOptions?.dateCreated === 'dec'}">
                            <i class="fa-regular fa-arrow-up-arrow-down text-primary-darker"
                                *ngIf="selectedSortOptions?.dateCreated === 'def'"></i>
                            <i class="fa-regular fa-arrow-up-long text-primary-darker"
                                *ngIf="selectedSortOptions?.dateCreated === 'asc'"></i>
                            <i class="fa-regular fa-arrow-down-long text-primary-darker"
                                *ngIf="selectedSortOptions?.dateCreated === 'dec'"></i>
                        </button>
                        <mat-menu #menuDateCreated="matMenu">
                            <button mat-menu-item (click)="customSortData('dateCreated', 'asc')" class="transparent-btn"
                                [ngClass]="{'bg-gray-1' : isAscSortMode}">
                                <span class="flexbox-row gap-8">
                                    <i class="fa-regular fa-arrow-up-long"></i>
                                    Ascending Order
                                </span>
                            </button>
                            <button mat-menu-item (click)="customSortData('dateCreated', 'dec')" class="transparent-btn"
                                [ngClass]="{'bg-gray-1' : isDesSortMode}">
                                <span class="flexbox-row gap-8">
                                    <i class="fa-regular fa-arrow-up-long"></i>
                                    Descending Order
                                </span>
                            </button>
                        </mat-menu>
                    </th>
                    <td mat-cell *matCellDef="let element" title="{{element.dateCreated}}" class="col-date position-relative">
                        <span class="ellipse">{{ element.dateCreated }}
                            <span *ngIf="element?.isSpinShown" class="smooth-gradient-ring-s action-loader"></span>
                        </span>
                    </td>
                </ng-container>

                <!-- Actions Column -->
                <ng-container matColumnDef="actions" stickyEnd>
                    <th mat-header-cell *matHeaderCellDef class="w-90 text-center">
                        Actions
                    </th>
                    <td mat-cell *matCellDef="let element; let rowIndex = dataIndex" class="w-90">
                        <div class="button-group justify-content-end w-100 flex-nowrap gap-12">
                            <!-- <button title="Archive" class="transparent-btn" *ngIf="element.statusid=== 8">
                                    <i class="fa-regular fa-box-archive grid-icon"></i>
                                  </button> -->
                                <ng-container *ngIf="router.url == '/dashboard/engagement/engagement-list'">
                                    <button mat-button class="button-text" title="Edit"
                                            [disabled]="!permissions?.hasEngEdit || element.statusid == 8 || element.statusid == 19 || (firm?.isPaused || billing?.isPaused) || (firm?.isDeleted || firm?.isDeleteInProgress) || element.statusid == 21"
                                            (click)="(!permissions?.hasEngEdit || element.statusid == 8 || element.statusid == 19 || (firm?.isPaused || billing?.isPaused) || (firm?.isDeleted || firm?.isDeleteInProgress))!= true ? editEngagement(element, 'allEngagements') :''">
                                        <i class="fa-regular fa-pen fs-15"></i>
                                    </button>
                                </ng-container>
                                <ng-container *ngIf="router.url == '/dashboard/members/client-engagements'">
                                    <button mat-button class="button-text" title="Edit"
                                            [disabled]="!permissions?.hasEngEdit || element.statusid == 8 || element.statusid == 19 || (firm?.isPaused || billing?.isPaused) || (firm?.isDeleted || firm?.isDeleteInProgress) || element.statusid == 21"
                                            (click)="(!permissions?.hasEngEdit || element.statusid == 8 || element.statusid == 19 || (firm?.isPaused || billing?.isPaused) || (firm?.isDeleted || firm?.isDeleteInProgress))!= true ? editEngagement(element, 'clientEngagemente') :''">
                                        <i class="fa-regular fa-pen fs-15"></i>
                                    </button>
                                </ng-container>

                                <button mat-button class="button-text" title="Delete"
                                        (click)="((element.statusid == 8 || element.statusid == 19) || !permissions?.hasEngDelete) != true ? deleteEngagement(element, element.engagementName,rowIndex):''"
                                        [disabled]="(element.statusid == 8 || element.statusid == 19 || element.statusid == 21) || !permissions?.hasEngDelete"
                                        [ngClass]="{'general':(element.statusid == 8 || element.statusid == 19) || !permissions?.hasEngDelete}">
                                    <i class="fa-regular fa-trash-can"></i>
                                </button>
                            </div>

                    </td>
                </ng-container>

                <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                <ng-container matColumnDef="expandedDetail">
                    <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                        <div class="expand-engList-detail"
                            [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                            <!-- <div class="auditor-firm team-details-row"> -->
                            <div class="team-details ps-4">
                                <ng-container *ngIf="element.auditorsData != 0 else noFirmTeam">
                                    <ul class="no-marg team-details-header">
                                        <li class="no-pad no-border">
                                            <div class="team-details-container flex-box-left">
                                                <div class="team-member" style="width: 220px;">
                                                    <div class="team-title">Firm Team</div>
                                                </div>
                                                <div class="team-member" style="width: 206px;">
                                                    <div class="team-title">Email</div>
                                                </div>
                                                <div class="team-member" style="width: 220px;">
                                                    <div class="team-title">Phone</div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </ng-container>
                                <ng-template #noFirmTeam>
                                    <div class="flex-box" style="width: 100%; height: 100%;">
                                        <div class="team-title">Firm Team not assigned</div>
                                    </div>
                                </ng-template>
                                <ul>
                                    <li *ngFor="let auditorDetails of element.auditorsData">
                                        <div class="team-details-container flex-box-col flex-box-left">
                                            <div class="team-member">
                                                <div class="team-member-short-name">
                                                    <ngx-avatars initialsSize="2" size="32"
                                                        [name]="auditorDetails.fullname"></ngx-avatars>
                                                    <!-- {{getShortName(auditorDetails.fullname)}} -->


                                                </div>


                                                <div class="team-member-full-name">
                                                    <h6 title={{auditorDetails.fullname}} class="text-ellipse">{{
                                                        auditorDetails.fullname }}</h6>
                                                    <p>
                                                        <i>{{ getRoleCount(auditorDetails.rowindex) }} {{ ' ' +
                                                            auditorDetails.rolename }}</i>
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="team-member">
                                                <div class="team-member-email">
                                                    <i class="fa-regular fa-envelope ico"></i>
                                                    <span class="user-name text-ellipse"
                                                        title={{auditorDetails.emailaddress}}>{{
                                                        auditorDetails.emailaddress }}</span>
                                                </div>
                                            </div>
                                            <div class="team-member">
                                                <div class="team-member-phone">
                                                    <i class="fa-regular fa-phone ico"></i>
                                                    <span class="user-name text-ellipse"
                                                        title={{auditorDetails.cellno}}>{{ auditorDetails.cellno
                                                        }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </li>

                                </ul>
                            </div>

                            <div class="team-details">
                                <ul class="no-marg team-details-header">
                                    <li class="no-pad no-border">
                                        <div class="team-details-container flex-box-left">
                                            <div class="team-member" style="width: 220px;">
                                                <div class="team-title">Client Team</div>
                                            </div>
                                            <div class="team-member" style="width: 206px;">
                                                <div class="team-title">Email</div>
                                            </div>
                                            <div class="team-member" style="width: 220px;">
                                                <div class="team-title">Phone</div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>

                                <ul>
                                    <li>
                                        <div class="team-details-container flex-box-col flex-box-left">
                                            <div class="team-member">
                                                <div class="team-member-short-name">
                                                    <ngx-avatars initialsSize="2" size="32"
                                                        [name]="element.contactperson"></ngx-avatars>
                                                    <!-- {{getShortName(element.contactperson)}} -->
                                                </div>
                                                <div class="team-member-full-name">
                                                    <h6 title="{{element.contactperson}}" class="text-ellipse">{{
                                                        element.contactperson }}</h6>
                                                    <p><i>Contact Person</i></p>
                                                </div>
                                            </div>
                                            <div class="team-member">
                                                <div class="team-member-email">
                                                    <i class="fa-regular fa-envelope ico"></i>
                                                    <span class="user-name text-ellipse"
                                                        title="{{element.emailaddress ? element.emailaddress : '-'}}">{{
                                                        element.emailaddress ?
                                                        element.emailaddress : '-' }}</span>
                                                </div>
                                            </div>
                                            <div class="team-member">
                                                <div class="team-member-phone">
                                                    <i class="fa-regular fa-phone ico"></i>
                                                    <span class="user-name text-ellipse"
                                                        title="{{element.cellphonenumber ? element.cellphonenumber : '-'}}">{{
                                                        element.cellphonenumber
                                                        ? element.cellphonenumber : '-' }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </li>

                                </ul>
                            </div>
                            <!-- </div> -->
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>

                <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="expanded-element-row"
                    [class.cust-expand-row]="expandedElement === element"></tr>

                <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="expanded-detail-row"
                    [class.cust-expanded-details-row]="expandedElement === row"></tr>
                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4" *ngIf="enagementFilter===sixMonthsFilter">No data matching in
                        last 6
                        month engagements. Please switch to All Engagement and search again.
                    </td>
                    <td class="mat-cell" colspan="4" *ngIf="enagementFilter!=sixMonthsFilter">No data matching.</td>
                </tr>
            </table>
        </ng-container>
    </div>
    } @else {
    <!-- If list empty -->
    <div class="no-data-found">
        <img src="./assets/images/ui-uplift-icons/global/empty-component-icon.svg" alt="Icon">
        <h6 class="title">Currently there are no engagements created</h6>
    </div>
    }
</div>


<!-- Delete Engagement Dialog -->
<ng-template #deleteEngagementDialog>
    <div class="countable-dialog confirmation-dailog" (click)="$event.stopPropagation()">
        <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center p-0">
            <span class="badge badge-error badge-circle icon-bordered-error">
                <i class="fa-regular fa-trash-can text-error"></i>
            </span>
            <h4 class="title text-center">Delete Engagement</h4>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark"></i>
            </button>
        </div>

        <div mat-dialog-content class="content dialog-body-content text-center gap-8 mt-2 mb-32">
            <p>You are trying to delete an existing engagement.</p>
            <p class="text-error fw-semibold my-2">This is an irreversible action.</p>
            <p>Do you want to continue?</p>
        </div>

        <div mat-dialog-actions class="dialog-footer button-group">
            <button mat-button mat-stroked-button class="button-default" color="dark" [mat-dialog-close]="false">Cancel
            </button>
            <button mat-button mat-flat-button class="button-default" color="error" [mat-dialog-close]="true"
                 >Delete
            </button>
        </div>
    </div>
</ng-template>

<!-- Delete Multiple Engagement Dialog -->
<ng-template #deleteMultiEngagementDialog>
    <div class="countable-dialog confirmation-dailog deleteMultiEngagementDialog" (click)="$event.stopPropagation()">
        <div mat-dialog-title class="dialog-header">
            <span class="badge badge-error badge-circle icon-bordered-error">
                <i class="fa-regular fa-trash-can text-error"></i>
            </span>
            <h4 class="title">Delete</h4>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark"></i>
            </button>
        </div>

        <div mat-dialog-content class="dialog-body-content">
            <p>You are trying to delete multiple engagements.</p>
            <p>Are you sure you want to continue?</p>
        </div>

        <div mat-dialog-actions class="dialog-footer">
            <button mat-button mat-stroked-button class="button-default" color="dark" [mat-dialog-close]="false">Cancel
            </button>
            <button mat-button mat-flat-button class="button-default" color="error" [mat-dialog-close]
                (click)="confirmMultiDeleteEngagement()">Delete
            </button>
        </div>
    </div>
</ng-template>
